import { createFileRoute, redirect } from "@tanstack/react-router";
import { IltFeedbackPage } from "@/features/instructor-led/feedback/IltFeedbackPage";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";

export const Route = createFileRoute("/_app/my-learning_/feedback/$bookingId")({
  // LMS-138: the feedback form of a face-to-face session, from the feedback email or My Learning.
  // Signing in comes first (the _app layout). Hidden while the ilt flag is off: back to My Learning.
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/my-learning" });
  },
  component: FeedbackRoute,
  remountDeps: ({ params }) => params.bookingId,
});

function FeedbackRoute() {
  const { bookingId } = Route.useParams();
  return <IltFeedbackPage bookingId={bookingId} />;
}
